import React, { useEffect, useState } from "react";
import RollingText from "../Components/RollingText/RollingText";
import Phone from "../Components/Phone/Phone";
import TypeWriter from "../Components/TypeWriter/TypeWriter";
import Rocket from "url:../assets/rocket-sml.mp4";
import MapVid from "url:../assets/map-sml.mp4";
import fullVid from "url:../assets/join.mp4";
import Video from "../Components/Video/Video";
import Pics from "../Components/Pics/Pics";

import goose from "../assets/duck.png";
import VideoTwo from "../Components/VideoTwo/VideoTwo";
import VideoThree from "../Components/VideoThree/VideoThree";
import Goose from "../Components/Goose/Goose";
import SlideShow from "../Components/SlideShow/SlideShow";

function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

const ComponentHandler = ({ component: subComponent }) => {
  const [pageComponent, setPageComponent] = useState(<></>);

  useEffect(() => {
    switch (subComponent) {
      case "rolling-text":
        setPageComponent(<RollingText />);
        break;
      case "phone":
        setTimeout(() => {
          setPageComponent(<Phone />);
        }, 7000);
        break;
      case "type-writer":
        setTimeout(() => {
          setPageComponent(<TypeWriter />);
        }, 4000);
        break;
      case "vid":
        if (!detectMob()) {
          setPageComponent(<Video Rocket={Rocket} />);
        } else {
          setPageComponent(<Video Rocket={false} />);
        }
        break;
      case "slide-show":
        setPageComponent(<SlideShow />);
        break;
      case "vidTwo":
        if (!detectMob()) {
          setPageComponent(<VideoTwo Rocket={MapVid} />);
        } else {
          setPageComponent(<VideoTwo Rocket={false} />);
        }

        break;
      case "vidThree":
        if (!detectMob()) {
          setPageComponent(<VideoThree Rocket={fullVid} />);
        } else {
          setPageComponent(<VideoThree Rocket={false} />);
        }
        break;
      case "pics":
        setPageComponent(<Pics />);
        break;
      case "goose":
        setPageComponent(<Goose goose={goose} />);
        break;
      default:
        break;
    }
  }, [subComponent]);
  return <>{pageComponent}</>;
};

export default ComponentHandler;
